import * as Types from '@seeqdev/api/graphql/types';

export type GqlTemplateLibraryQueryVariables = Types.Exact<{
  filter: Types.InputMaybe<Types.GqlTemplateSearchFilterInput>;
  limit: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GqlTemplateLibraryQuery = { __typename?: 'Query', templates: { __typename?: 'TemplatePage', totalResults: number, items: Array<{ __typename?: 'TemplateContainer', id: string, name: string, effectivePermissions: { __typename?: 'PermissionsGraphQL', write: boolean }, productionVersion: { __typename?: 'TemplateVersion', number: number } | undefined, draft: { __typename?: 'TemplateDraft', id: string } | undefined }> } };

/* Appended by scripts/generate-gql-apis.ts: hooks dispatch through sqTemplatesGqlApi so tests can
   intercept them with jest.spyOn(sqTemplatesGqlApi, 'templateLibrary'). */
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useAxiosInstance } from '../../../src/reactQuery/ApiProvider.context';
import { sqTemplatesGqlApi } from './sqTemplatesGqlApi';

export const TemplateLibraryDocument = `query TemplateLibrary($filter: TemplateSearchFilterInput, $limit: Int) {
  templates(filter: $filter, limit: $limit) {
    totalResults
    items {
      id
      name
      effectivePermissions {
        write
      }
      productionVersion {
        number
      }
      draft {
        id
      }
    }
  }
}`;

export const useTemplateLibraryQuery = <TData = GqlTemplateLibraryQuery, TError = unknown>(
  variables?: GqlTemplateLibraryQueryVariables,
  options?: Omit<UseQueryOptions<GqlTemplateLibraryQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GqlTemplateLibraryQuery, TError, TData>['queryKey'];
  },
) => {
  const axiosInstance = useAxiosInstance();
  return useQuery<GqlTemplateLibraryQuery, TError, TData>({
    queryKey: variables === undefined ? ['TemplateLibrary'] : ['TemplateLibrary', variables],
    queryFn: () => sqTemplatesGqlApi.templateLibrary(variables, { axiosInstance }),
    ...options,
  });
};

useTemplateLibraryQuery.getKey = (variables?: GqlTemplateLibraryQueryVariables) => variables === undefined ? ['TemplateLibrary'] : ['TemplateLibrary', variables];
